import React, { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './Dedication.styled';
import { StyledInput } from '../../../atoms/Input';
import { CheckboxWithTooltip } from '../../../molecules/CheckboxWithTooltip/CheckboxWithTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Dedication = _ref => {
  let {
    dedicationError,
    showDedication,
    handleCheckChange,
    handleDedicationChange
  } = _ref;
  const {
    t
  } = useTranslation('blocks.donation');
  const [checked, setChecked] = useState(showDedication);
  const [touched, setTouched] = useState(false);
  const checkboxWithTooltipId = useId();
  const inputId = useId();

  // Only show error if field has been touched (blurred) and there is an error
  const showError = touched && dedicationError;
  const handleInputChange = e => {
    const newValue = e.target.value.trim();

    // Call handleDedicationChange, which computes the error and sets the input
    handleDedicationChange(newValue);
    setTouched(true);
  };
  const handleInputBlur = () => {
    setTouched(true);
  };
  return /*#__PURE__*/_jsxs(Styled.Container, {
    children: [/*#__PURE__*/_jsx(CheckboxWithTooltip, {
      id: checkboxWithTooltipId,
      label: t('Dedication.label', 'Dedicate my donation to'),
      tooltipText: t('Dedication.tooltip', 'You can personalize and send your dedication after completing your donation'),
      tooltipProps: {
        placement: 'top'
      },
      checkboxProps: {
        onChange: e => {
          handleCheckChange(e.target.checked);
          setChecked(e.target.checked);
          if (!e.target.checked) {
            setTouched(false);
          }
        }
      }
    }), checked && /*#__PURE__*/_jsx(Styled.Input, {
      children: /*#__PURE__*/_jsx(StyledInput, {
        id: inputId,
        "aria-label": t('Dedication.inputAriaLabel', 'Who do you want to dedicate this donation to?'),
        placeholder: t('Dedication.placeholder', 'Enter name'),
        "aria-invalid": !!showError,
        onChange: handleInputChange,
        onBlur: handleInputBlur,
        autoFocus: true
      })
    }), /*#__PURE__*/_jsx(Styled.ErrorLabel, {
      role: "alert",
      "aria-live": "assertive",
      "aria-relevant": "additions",
      children: showError && `\u26A0 ${dedicationError}`
    })]
  });
};